import moment from "moment"
import React from "react"
import { Badge, Card, Col, ListGroup, Row } from "react-bootstrap"

export default function AppointmentHistory({
    getDataAppointmentPatient,
}) {
    return (
        <>
            <Card className="mb-4 shadow-sm border-secondary">
                <Card.Header as="h6" className="bg-secondary text-white small">
                    📅 Riwayat Appointment
                </Card.Header>
                <Card.Body className="p-0" style={{ height: '180px', overflowY: 'auto', overflowX: 'auto' }}>
                    <div style={{ minWidth: '800px' }}>
                        <table className="table table-bordered table-striped table-sm mb-0 small">
                            <thead className="table-light text-center">
                                <tr>
                                    <th>📌 Kode Appointment</th>
                                    <th>📝 Anamnesa</th>
                                    <th>👨‍⚕️ Dokter</th>
                                    <th>👤 Admin</th>
                                    <th>📅 Tanggal</th>
                                    <th>⏰ Waktu</th>
                                </tr>
                            </thead>
                            <tbody>
                                {getDataAppointmentPatient?.length > 0 ? (
                                    getDataAppointmentPatient.map((appointment, index) => (
                                        <tr key={index}>
                                            <td className="text-center">{appointment.code}</td>
                                            <td className="text-center">{appointment.anamnesa}</td>
                                            <td className="text-center">
                                                {appointment.doctor.user_detail.firstname} {appointment.doctor.user_detail.lastname}
                                            </td>
                                            <td className="text-center">
                                                {appointment.admin.user_detail.firstname} {appointment.admin.user_detail.lastname}
                                            </td>
                                            <td className="text-center">{appointment.date}</td>
                                            <td className="text-center">{appointment.time}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="6" className="text-center">
                                            Tidak ada data appointment
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </Card.Body>
            </Card>
        </>
    )
}